module.exports = __webpack_public_path__ + "media/images/lb/926-1a2b2f1020359d0a11a219deefa0b612.svg";